<template>
  <div class="button" @click="handleClick"></div>
</template>

<script>
export default {
  name: "ArButton",
  methods:{
    handleClick(e){
      this.$emit('click',e)
    }
  }
};
</script>
<style scoped lang="stylus">
.button {
  position relative
  margin 15px
  border-radius 50%
  background-color: #00000052;
  backdrop-filter: blur(10px);
  width 45px
  height 45px
  background-size 40%
  background-position center
  box-sizing border-box
  background-repeat no-repeat
  &:hover{
    cursor pointer
  }
  &:hover{
    transform scale(1.05)
    &:before{
      display: block;
      position: absolute;
      top -80%;
      left -100%
      padding: 6px;
      background-color: rgba(30,30,30,0.8);
      color: white;
      text-align center;
      width 10em
      border-radius 6px
    }
  }
}
</style>
